// extracted by mini-css-extract-plugin
module.exports = {"tabsContentInner":"EditRoleTabs_tabsContentInner__3msu5"};